import RouterMixin from 'Support/mixins/router-mixin';

export default {
  mixins: [RouterMixin],
  created() {
    this.updatePayloadWithQueryString();
  },
  methods: {
    updatePayloadWithQueryString() {
      const { query } = this.$route;
      const keys = Object.keys(this.payload);
      keys.forEach((key) => {
        if (Array.isArray(this.payload[key])) {
          if (query[key]) {
            if (query[key].includes(',')) {
              this.payload[key] = query[key].split(',');
            } else {
              this.payload[key][0] = query[key];
            }
          }
        } else {
          this.payload[key] = query[key] || null;
        }
      });
    },
    filter() {
      const filterPayload = this.cleanupPayload();
      const handleFIltersNotNullables = this.setNotNulableFilters(filterPayload);

      this.updateQueryParams(handleFIltersNotNullables);
    },
    clearFilter() {
      const keys = Object.keys(this.payload);
      keys.forEach((key) => {
        if (Array.isArray(this.payload[key])) {
          this.payload[key] = [];
        } else {
          this.payload[key] = null;
        }
      });
      this.$router.push({});
    },
    setNotNulableFilters(filters) {
      const handleFilters = this.prepareFilter(filters);

      return this.checkNotNullablefilter(handleFilters);
    },
    prepareFilter(payload) {
      return payload;
    },
    cleanupPayload() {
      const keys = Object.keys(this.payload);
      const filterPayload = {};
      keys.forEach((key) => {
        filterPayload[key] = this.payload[key] || undefined;
      });

      return filterPayload;
    },
    checkNotNullablefilter(filters) {
      return Object.keys(filters)
        .reduce(
          (obj, key) => {
            const override = obj;
            const item = filters[key];

            if (![null, undefined, ''].includes(item)) {
              override[key] = item;
            }

            return override;
          },
          {},
        );
    },
  },
};
